<template>
    <tr v-if="selectionModel.currentStep !== 'viewreport'">
        <template v-if="!viewport1">
            <td>Estimated Execution Time</td>
            <td :class="timeClass">
                <div>
                    <div>{{ executionStats.seconds }} Seconds</div>
                </div>
            </td>
        </template>
        <template v-if="viewport1">
            <td>
                <div>Estimated Execution Time</div>
                <div :class="timeClass">
                    <div>
                        <div>{{ executionStats.seconds }} Seconds</div>
                    </div>
                </div>
            </td>
        </template>
    </tr>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import current from '@/scripts/current';
import store from '@/store';

export default {
    props: ['viewport1'],
    computed: {
        ...mapGetters({
            executionStats: 'selModel/getExecutionStats'
        }),
        selectionModel: function () {
            return current.selectionModel;
        }
    },
    watch: /*deep*/ {
        executionStats: {
            handler: function (value) {
                this.timeStyle = getSecondsStyle(value.seconds);
                this.timeClass = getSecondsClass(value.seconds);
            },
            deep: true
        }
    },
    created: function () {},
    data: function () {
        const seconds = store.state.selModel.executionStats.seconds;
        return {
            timeStyle: getSecondsStyle(seconds),
            timeClass: getSecondsClass(seconds)
        };
    },
    methods: {}
};

function getSecondsStyle(seconds) {
    var m = current.selectionModel;
    if (
        m.currentStep === 'years' ||
        (m.currentStep === 'location' &&
            m.selectedLocations.length === 0 &&
            (m.selectedLocation === -1 || m.selectedLocation === '-1'))
    )
        return '';
    return seconds >= 60
        ? 'color: red; font-weight: bold;'
        : seconds >= 30
        ? 'color: orange; font-weight: bold;'
        : '';
}

function getSecondsClass(seconds) {
    var m = current.selectionModel;
    if (
        m.currentStep === 'years' ||
        (m.currentStep === 'location' &&
            m.selectedLocations.length === 0 &&
            (m.selectedLocation === -1 || m.selectedLocation === '-1'))
    )
        return '';
    return seconds >= 60 ? 'is-red' : seconds >= 30 ? 'is-yellow' : '';
}
</script>

<style scoped>
td > div:first-child {
    font-weight: 500;
}

.is-red > div {
    background-color: #ff4d4d;
    color: black;
}

.is-yellow > div {
    background-color: yellow;
    color: black;
}

.is-red > div,
.is-yellow > div {
    width: 140px;
    height: 22px;
    border-radius: 5px;
}

.is-red > div > div,
.is-yellow > div > div {
    vertical-align: center;
    width: 100%;
    margin: auto;
    width: fit-content;
    font-weight: bold;
    font-size: 14px;
}
</style>
